module.exports = __webpack_public_path__ + "img/Assinatura_Fabio_Vasconcelos.3000414c.png";